import { collectReservationAnalyticsContext, buildReservationAnalyticsEvent } from './analyticsEvents.ts';
import { getReservationAnalyticsSession } from './analyticsSession.ts';
import { validateReservationAnalyticsEvent } from './analyticsValidation.ts';
import type { ReservationAnalyticsEventType, ReservationAnalyticsWriter } from './analyticsTypes.ts';

const seen = new Set<string>();
const dedupeKey = (unitId: string, eventType: string, sessionId: string) =>
  eventType === 'page_view' ? `${unitId}:${sessionId}:${eventType}` : null;

export const trackReservationAnalyticsEvent = (input: {
  unitId: string;
  eventType: ReservationAnalyticsEventType;
  locale: string;
  unitTimezone?: string;
  writer: ReservationAnalyticsWriter;
}): void => {
  console.log('[Analytics] entered trackReservationAnalyticsEvent', {
    eventType: input.eventType,
    unitId: input.unitId,
    writerType: typeof input.writer,
  });
  queueMicrotask(() => {
    console.log('[Analytics] microtask entered');
    try {
      const session = getReservationAnalyticsSession();
      console.log('[Analytics] session created', {
        sessionId: session.sessionId,
        visitorId: session.visitorId,
      });
      const key = dedupeKey(input.unitId, input.eventType, session.sessionId);
      if (key && seen.has(key)) {
        console.log('[Analytics] page_view dedupe skipped', { key });
        return;
      }
      const event = buildReservationAnalyticsEvent({
        unitId: input.unitId,
        eventType: input.eventType,
        session,
        context: collectReservationAnalyticsContext(input.locale, input.unitTimezone),
      });
      console.log('[Analytics] event built', {
        eventId: event.eventId,
        unitId: event.unitId,
        eventType: event.eventType,
      });
      console.log('[Analytics] validation started');
      const errors = validateReservationAnalyticsEvent(event);
      console.log('[Analytics] validation result', errors);
      if (errors.length) {
        console.error('[Analytics] validation failed', errors);
        return;
      }
      if (key) seen.add(key);
      console.log('[Analytics] writer.create entered', {
        writerType: typeof input.writer,
        createType: typeof input.writer?.create,
      });
      void input.writer.create(event).catch(error => {
        console.error('[Analytics] writer.create rejected', error);
      });
    } catch (error) {
      console.error('[Analytics] trackReservationAnalyticsEvent failed', error);
      // Analytics must never interrupt the public reservation flow.
    }
  });
};
